import { Button, Col, Progress, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getClassCategoryArray } from '../../../hooks/getClassCategoryArray';
import { numberWithSpacesInter } from '../../../helpers/formatInteger';

const OptimAssetsClass = ({
  currentData,
  optimalData,
  cashesList,
  currencyList,
}) => {
  const { t } = useTranslation('');

  const { assets } = useSelector((state) => state.instrumentsReducer);

  const [asseCurrentData, setAsseCurrentData] = useState(null);
  const [asseOptData, setAsseOptData] = useState(null);

  useEffect(() => {
    if (currentData && currencyList) {
      const newData = getClassCategoryArray([currentData], cashesList, assets, true);
      setAsseCurrentData(newData);
    }
  }, [currentData, cashesList, currencyList]);

  const optimPrepare = (optimalData) => {
    if (optimalData) {
      const newCashes = optimalData?.portfolio_cashes;
      const newListed = optimalData?.portfolio_content?.map((i) => {
        const {
          asset_class_id,
          value,
          current_weight_fin,
          financialAssetCategory: { id },
        } = i;
        return {
          financial_asset_id: asset_class_id,
          financial_asset_category_id: id,
          value,
          current_weight_fin,
        };
      });
      const newUnlisted = optimalData?.unlisted_content?.map((i) => {
        const {
          asset_class_id,
          value,
          current_weight_fin,
          financialAssetCategory: { id },
        } = i;
        return {
          financial_asset_id: asset_class_id,
          financial_asset_category_id: id,
          value,
          current_weight_fin,
        };
      });
      const returnData = {
        portfolio_cashes: newCashes,
        portfolio_content: newListed,
        unlisted_content: newUnlisted,
      };
      return returnData;
    }
  };

  useEffect(() => {
    if (optimalData && currencyList) {
      const newData = getClassCategoryArray(
        [optimPrepare(optimalData)],
        cashesList,
        assets,
      );
      setAsseOptData(newData);
    }
  }, [optimalData, cashesList, currencyList]);

  const handleTabs = () => {
    setTabs(tabs ? 0 : 1);
  };

  const [tabs, setTabs] = useState(0);
  return (
    <div className="class-side-wrap">
      <Row
        className="class-side-headers"
        justify={'space-between'}
        style={{ padding: '24px' }}
      >
        <Col>
          <Button
            type="text"
            className={`portfolio-tabs-btn ${tabs === 0 ? 'selected' : ''}`}
            onClick={handleTabs}
          >
            {t('CATEGORY')}
          </Button>
          <Button
            type="text"
            className={`portfolio-tabs-btn ${tabs === 1 ? 'selected' : ''}`}
            onClick={handleTabs}
          >
            {t('CLASS')}
          </Button>
        </Col>
        <Col></Col>
      </Row>
      <div className="class-category-wrapper left">
        {tabs === 0 &&
          asseCurrentData?.category?.map((item) => (
            <div className="client table-wrapper" key={item.name}>
              <div className="table-date-row">
                <div>
                  <p className="table-date-name">{item.name?.toUpperCase()}</p>
                  <p className="table-date-value">{`${numberWithSpacesInter(item.value, 0)} kr`}</p>
                </div>
                <div className="table-date-persent">
                  {numberWithSpacesInter(item.weight, 2)}%
                </div>
              </div>
              <Progress
                className="table-date-progress"
                percent={item.weight.toFixed(2)}
                showInfo={false}
                strokeColor={'#FB7B34'}
                size={{ height: 2 }}
                trailColor={'transparent'}
              />
            </div>
          ))}
      </div>
      <div className="class-category-wrapper">
        {tabs === 0 &&
          asseOptData?.category?.map((item) => (
            <div className="client table-wrapper" key={item.name}>
              <div className="table-date-row">
                <div>
                  <p className="table-date-name">{item.name?.toUpperCase()}</p>
                  <p className="table-date-value">{`${numberWithSpacesInter(item.value, 0)} kr`}</p>
                </div>
                <div className="table-date-persent opt">
                  {numberWithSpacesInter(item.weight, 2)}%
                </div>
              </div>
              <Progress
                className="table-date-progress"
                percent={item.weight.toFixed(2)}
                showInfo={false}
                strokeColor={'#6467C3'}
                size={{ height: 2 }}
                trailColor={'transparent'}
              />
            </div>
          ))}
      </div>
      <div className="class-category-wrapper left">
        {tabs === 1 &&
          asseCurrentData?.class?.map((item) => (
            <div className="client table-wrapper" key={item.name}>
              <div className="table-date-row">
                <div>
                  <p className="table-date-name">{item.name?.toUpperCase()}</p>
                  <p className="table-date-value">{`${numberWithSpacesInter(item.value, 0)} kr`}</p>
                </div>
                <div className="table-date-persent">
                  {numberWithSpacesInter(item.weight, 2)}%
                </div>
              </div>
              <Progress
                className="table-date-progress"
                percent={item.weight.toFixed(2)}
                showInfo={false}
                strokeColor={'#FB7B34'}
                size={{ height: 2 }}
                trailColor={'transparent'}
              />
            </div>
          ))}
      </div>
      <div className="class-category-wrapper">
        {tabs === 1 &&
          asseOptData?.class?.map((item) => (
            <div className="client table-wrapper" key={item.name}>
              <div className="table-date-row">
                <div>
                  <p className="table-date-name">{item.name?.toUpperCase()}</p>
                  <p className="table-date-value">{`${numberWithSpacesInter(item.value, 0)} kr`}</p>
                </div>
                <div className="table-date-persent opt">
                  {numberWithSpacesInter(item.weight, 2)}%
                </div>
              </div>
              <Progress
                className="table-date-progress"
                percent={item.weight.toFixed(2)}
                showInfo={false}
                strokeColor={'#6467C3'}
                size={{ height: 2 }}
                trailColor={'transparent'}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default OptimAssetsClass;

OptimAssetsClass.propTypes = {
  currentData: PropTypes.object,
  optimalData: PropTypes.object,
  cashesList: PropTypes.array,
  currencyList: PropTypes.array,
};
